import { connect } from "react-redux";
import TrTableFaq from "./tr-table";

const TableFaq = (props) => {
   const { faqs } = props;
   return (
      <table className="app-v2-table app-v2-table-fixed">
         <thead className="app-v2-table-thead">
            <tr className="app-v2-table-tr">
               <th className="app-v2-table-th text-left-i" style={{ width: 320 }}>Nếu khách chọn câu hỏi</th>
               <th className="app-v2-table-th text-left-i" style={{ width: '100%' }}>Nội dung trả lời sẽ là</th>
               <th className="app-v2-table-th text-right-i" style={{ width: 96 }}>Hành động</th>
            </tr>
         </thead>
         <tbody className="app-v2-table-tbody">
            {faqs.map((faq, index) => (
               <TrTableFaq key={index} faq={faq} />
            ))}
         </tbody>
      </table>

   )
}

const mapStateToProps = (state) => {
   const { faq } = state;
   const { items } = faq.faqs;
   return {
      faqs: items
   };
};

export default connect(mapStateToProps, {
})(TableFaq);